export default "__VITE_ASSET__fPSO5de$__"